import { render } from "./more-boat.vue?vue&type=template&id=3b5efbe1"
import script from "./more-boat.vue?vue&type=script&lang=js"
export * from "./more-boat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__